import React, { Component, Fragment } from 'react';
import { Button, Header, Icon, Loader, Segment, SegmentGroup } from 'semantic-ui-react';
import { checkFaculty, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, getTotalNumberOfPages } from '../util/util';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { FiltersOnStyle, IconHeader } from '../util/css';
import NewResource from './NewResource';
import ResourceList from './ResourceList';
import { FACULTY_ADMIN, fetchActiveRole, fetchUserOrganizationalUnit, UNIVERSITY_SUPER_ADMIN } from '../util/roles';
import { ToastContainer } from 'react-toastify';
import PaginationSegment from '../util/PaginationSegment';

class Resources extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            equipments: [],
            filteredEquipment: [],
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
            loader: true
        };
        this.getUserData = this.getUserData.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.fetchEquipment = this.fetchEquipment.bind(this);
        this.fetchAllEquipment = this.fetchAllEquipment.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.updateEquipment = this.updateEquipment.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getWritePrivilege = this.getWritePrivilege.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('property');
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ activeRole, organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchEquipment();
                } else {
                    this.fetchAllEquipment();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                // console.log('Failed to fetch data.');
            });
    }

    fetchEquipment(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post('/assets/equipment/paginated/', { ...pagination }).then((res) => {
            const equipments = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ equipments, totalPages, loader: false });
            this.updateEquipment(page, resultsPerPage, res);
        });
    }

    fetchAllEquipment(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post('/assets/equipment/all/', { ...pagination }).then((res) => {
            const equipments = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ equipments, totalPages, loader: false });
            this.updateEquipment(page, resultsPerPage, res);
        });
    }


    activateEditRequest() {
        this.setState({ activateEditRequest: true });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filteredEquipment;
        }
        return this.state.equipments;
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredEquipment(activePage - 1, this.state.resultsPerPage);
        } else if (checkFaculty(this.state.activeRole)) {
            this.fetchEquipment(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchAllEquipment(activePage - 1, this.state.resultsPerPage);
        }
    }

    updateEquipment(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }

    getWritePrivilege() {
        const activeRole = localStorage.getItem('activeRole');
        if (activeRole === FACULTY_ADMIN || activeRole.substr(0, 18) === FACULTY_ADMIN || activeRole === UNIVERSITY_SUPER_ADMIN) {
            return true;
        }
        return false;
    }

    render() {
        const equipment = this.getDataToRender();
        const writePrivilege = this.getWritePrivilege();
        const {
            openNewResource,
        } = this.state;
        if (this.state.activateEditRequest) {
            return <Redirect push to={{ pathname: '/imovina/sredstva/detalji' }} />;
        }
        return (
            // eslint-disable-next-line react/jsx-no-undef
            <div>
                <Header as="h1">Sredstva</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak opreme
                            {writePrivilege &&
                            <Header style={IconHeader} floated="right"> <Button
                                color="blue"
                                floated="right"
                                icon
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => this.setState({ openNewResource: true })}
                            ><Icon className="add" />
                                Dodavanje opreme
                            </Button>
                            </Header>
                            }
                        </Header>
                    </Segment>
                    <Segment>
                        {this.state.openNewResource && <NewResource
                            organizationalUnitId={this.state.organizationalUnitId}
                            activeRole={this.state.activeRole}
                            fetchAllEquipment={this.fetchAllEquipment}
                            fetchEquipment={this.fetchEquipment}
                            closeForm={() => this.setState({ openNewResource: false })}
                        />}
                        {this.state.loader ?
                            <Loader active inline="centered" />
                            : equipment && equipment.length ?
                                <Fragment>
                                    <ResourceList
                                        equipment={equipment}
                                        activateEditRequest={this.activateEditRequest}
                                    />
                                    <PaginationSegment
                                        activePage={this.state.activePage}
                                        totalPages={this.state.totalPages}
                                        onPageChange={this.handlePageChange}
                                    />
                                </Fragment> : 'Nema podataka o opremi.'
                        }

                    </Segment>
                </SegmentGroup>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/views/Assets/Resources/Resources.js